// src/rms/data/index.js
// ============================================================================
// Adapter selection
// ============================================================================
// VITE_RMS_BACKEND=local     â†’ browser storage, no backend (default)
// VITE_RMS_BACKEND=supabase  â†’ the rms_* schema in Supabase
//
// Everything above this layer talks to `db` and never imports an adapter
// directly, so attaching a real backend is a one-line env change.
// ============================================================================

import localAdapter from "./localAdapter";
import supabaseAdapter from "./supabaseAdapter";

const BACKEND = (import.meta.env.VITE_RMS_BACKEND || "local").toLowerCase();

export const db = BACKEND === "supabase" ? supabaseAdapter : localAdapter;

export const isLocalBackend = db.name === "local";

if (import.meta.env.DEV) {
  console.info(`[ReserveZoo] RMS data backend: ${db.name}`);
}

export default db;
